import { render, staticRenderFns } from "./TournamentTeamRank.vue?vue&type=template&id=a9ac2260&"
import script from "./TournamentTeamRank.vue?vue&type=script&lang=js&"
export * from "./TournamentTeamRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports